import type { MenuItem } from '@/types';
import { t } from '@/locales/i18n';
import { computed } from 'vue';

export const siteTree = computed<MenuItem[]>(() => [
  {
    title: t('home.techMeasuresTab'),
    to: '/tech-measures'
  },
  {
    title: t('home.renewableEnergyTab'),
    to: '/renewable-energy'
  }
]);
